import { Button, ConfigProvider, Input, theme } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorPage from './ErrorPage';

const CitizenIdRequiredPage = ({ error, onSubmit, showHeader = true }) => {
  const [pass, setPass] = useState('');
  const [passChanged, setPassChanged] = useState(false);
  const { t } = useTranslation('ViewerTool');

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontSize: 12,
          borderRadiusSM: 2,
          borderRadiusLG: 2,
          borderRadius: 2,
          colorPrimary: '#39C2D7',
          colorPrimaryHover: '#2799b0',
          colorText: '#fff',
          colorBgBase: '#172126',
          colorBgContainer: 'transparent',
          colorBorder: '#647a87',
          controlItemBgActiveDisabled: '#2C4654',
          controlItemBgActive: '#2C4654',
          controlOutlineWidth: 0,
          colorBgElevated: '#1F313B',
        },
        components: {
          Menu: {
            colorItemBg: 'transparent',
            colorItemBgSelected: '#2c5166',
          },
        },
      }}
    >
      <ErrorPage
        showHeader={showHeader}
        textBlock={
          <div className="flex flex-col items-center">
            {error && !passChanged ? (
              <div className="mb-2 text-red-600">{t('Invalid Citizen ID')}</div>
            ) : (
              <div className="mb-2">{t('Citizen ID Required')}</div>
            )}
            <input type="password" style={{ display: 'none' }}></input>
            <Input
              className="mb-2"
              // name="passcode"
              autoComplete="off"
              // type="password"
              placeholder={t('Enter Citizen ID')}
              onChange={(val) => {
                setPass(val.target.value);
                setPassChanged(true);
              }}
              onPressEnter={() => onSubmit(pass)}
            />
            <Button className="mb-2 flex items-center" onClick={() => onSubmit(pass)}>
              {t('Submit')}
            </Button>
          </div>
        }
      />
    </ConfigProvider>
  );
};

export default CitizenIdRequiredPage;
